import { render, staticRenderFns } from "./ICH.vue?vue&type=template&id=dd5bef12&scoped=true&"
import script from "./ICH.vue?vue&type=script&lang=js&"
export * from "./ICH.vue?vue&type=script&lang=js&"
import style0 from "./ICH.vue?vue&type=style&index=0&id=dd5bef12&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5bef12",
  null
  
)

export default component.exports